import { useEffect, useState } from "react";
import { _get, _post} from "../../../../apiClient";
import "./Candidate.css"
import { useMemo } from 'react';
import { MaterialReactTable, useMaterialReactTable, type MRT_ColumnDef} from 'material-react-table';
import { useIsReverseResult } from "../../../context/isReverseMatchingResult";
import TableMatches from "../Match/Match"
import LoaderComp from "../../../loader/Loader";
import chevronUp from "../../../../images/chevron-up.svg";
import chevronDown from "../../../../images/chevron-down.svg";
import SidebarRev from "../Sidebar/SidebarRev";
import { format } from "date-fns";
import { useIsMatchingRealTimeRev } from "../../../context/isMatchingRealTimeRev";
import { useIsInfoPage } from "../../../context/isInfoPage";
import { useInfoString } from "../../../context/infoString";
import InfoPage from "../../Info/InfoPage";

function TableCandidate(props: any) {
  const [candidates, setCandidates] = useState([])
  const [associateId, setAssociate] = useState("");
  const { isReverseResult, toggleView } = useIsReverseResult();
  const [row, setRow] = useState([]);
  const [headers, setHeaders] = useState({});
  
  const [timeElapsed, setTimeElapsed] = useState(false);

  const [sidebarOpen, setSideBarOpen] = useState(false);
  const { isMatchingRealTimeRev, toggleViewRealRev } = useIsMatchingRealTimeRev();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [checkList, setCheckList] = useState<any[]>([])

  const { isInfoPage, toggleViewInfoPage } = useIsInfoPage();
  const { infoString, setInfoString } = useInfoString();

  const [isDetails, setDetails] = useState(false);
  const [iqg, setIqg] = useState(false);
  const [email, setEmail] = useState(false);
  const [emailC, setEmailC] = useState(false);
  const [emails, setEmails] = useState([]);
  const [emailsC, setEmailsC] = useState([]);
  const [questions, setQuestions] = useState([])
  const [matches, setMatches] = useState([])
  const [explain, setExplain] = useState<any>({})
  const [headersNew, setHeadersNew] = useState<any>({})
  const [jobId, setJobId] = useState('');
  const [rowValues, setRowValues] = useState<any>({});
  const [urlPDF, setUrlPDF] = useState("");
  const [cvs, setCvs] = useState("")
  const [codFisc, setCodFisc] = useState("")
  const [jobInfos, setJobInfos] = useState([])
  const [interviste, setInterviste] = useState([])
  const [ordini, setOrdini] = useState([])
  const [jobInfo, setJobInfo] = useState(false);
  const [ordine, setOrdine] = useState(false);
  const [intervista, setIntervista] = useState(false);
  const [cv, setCv] = useState(false);
  const [timeJobInfo, setTimeJobInfo] = useState(false)
  const [timeOrdine, setTimeOrdine] = useState(false)
  const [timeCvsJob, setTimeCvsJob] = useState(false)
  const [timeIntervista, setTimeIntervista] = useState(false)
  const [isAI, setIsAI] = useState(false)
  const [defaultMatches, setDefaultMatches] = useState<string[]>([]);
  const [isSeen, setIsSeen] = useState<any>(0)

  const [initialOrderOffers, setInitialOrderOffers] = useState<string[]>([]);
  const handleViewSidebar = () => {
    setSideBarOpen(!sidebarOpen);
  };

  const [activeContent, setActiveContent] = useState(
    isMatchingRealTimeRev ? "realtime" : "normal"
  );

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const switchContent = () => {
    setActiveContent((prevContent) =>
      prevContent === "normal" ? "realtime" : "normal"
    );
    toggleViewRealRev();
    setIsDropdownOpen(false);
  };

  const setResult = (associate_id: any, row:any) => {
    setAssociate(associate_id)
    setRow(row);
    setHeaders(Object.keys(row))
    toggleView(false);
  }
  interface Candidate {
    Codice_Fiscale: string;
    Stato_Candidato: string;
    Stato_Collaboratore: string;
    last_certification_date: Date;
    name: string;
    surname: string;
    home_city: string;
    home_province: string;
    Classe_Eta: string;
    professional_categories_profile: string;
    last_5_group_prof_cat_applications: string;
    matters_known: string;
    regulated_trainings: string;
    languages: string;
    driving_licenses: string;
    last_5_clients: string;
    register_date: Date;
    last_activity_date: Date;
    has_disadvantage: string;
    CDC_DI: string;
    Categoria_protetta: Date;
    Type_handicap_percentage: string;
    sl_bench: string;
    most_recent_activity: string;
  }



  const columns = useMemo<MRT_ColumnDef<Candidate>[]>(
    () => [
      {
        accessorKey: 'Codice_Fiscale',
        header: 'Id Candidato',
        size: 100
      },
      {
        accessorKey: 'Stato_Candidato',
        header: 'Stato Candidato',
        size: 150
      },
      {
        accessorKey: 'Stato_Collaboratore',
        header: 'Stato Collaboratore',
        size: 25
      },
      {
        accessorKey: 'last_activity_date',
        header: "Data ultima attività",
        Cell: ({ row }) => format(new Date(row.original.last_activity_date), "yyyy-MM-dd"),
        size: 150
      },
      {
        accessorKey: 'last_certification_date',
        header: 'Ultima data certificazione',
        Cell: ({ row }) => format(new Date(row.original.last_certification_date), "yyyy-MM-dd"),
        size: 25
      },
      {
        accessorKey: 'home_city',
        header: 'Città domicilio',
        size: 25
      },
      {
        accessorKey: 'home_province',
        header: 'Provincia domicilio',
        size: 100
      },
      {
        accessorKey: 'Classe_Eta',
        header: 'Classe Età',
        size: 100
      },
      {
        accessorKey: 'professional_categories_profile',
        header: "Categoria professionale d'interesse",
        size: 150
      },
      {
        accessorKey: 'name',
        header: 'Nome',
        size: 200
      },
      {
        accessorKey: 'surname',
        header: 'Cognome',
        size: 200
      },
      {
        accessorKey: 'last_5_group_prof_cat_applications',
        header: "Ultime 5 categorie d'application",
        size: 150
      },
      {
        accessorKey: 'matters_known',
        header: "Skill",
        size: 150
      },
      {
        accessorKey: 'regulated_trainings',
        header: "Education",
        size: 150
      },
      {
        accessorKey: 'languages',
        header: "Lingue",
        size: 150
      },
      {
        accessorKey: 'driving_licenses',
        header: "Patenti",
        size: 150
      },
      {
        accessorKey: 'last_5_clients',
        header: "Ultimi 5 clienti",
        size: 150
      },
      {
        accessorKey: 'register_date',
        header: "Data registrazione",
        Cell: ({ row }) => format(new Date(row.original.register_date), "yyyy-MM-dd"),
        size: 150
      },
      {
        accessorKey: 'has_disadvantage',
        header: "Categoria svantaggiata",
        size: 150
      },
      {
        accessorKey: 'CDC_DI',
        header: "CDC D&I",
        size: 150
      },
      {
        accessorKey: 'Categoria_protetta',
        header: "Categoria Protetta (Intervista)",
        size: 150
      },
      {
        accessorKey: 'Type_handicap_percentage',
        header: "Handicaps",
        size: 150
      },
      {
        accessorKey: 'career_guidance_name',
        header: "Dote Attiva",
        size: 150
      },
      {
        accessorKey: 'sl_bench',
        header: "Collaboratore in Disponibilità",
        size: 200
      },
      {
        accessorKey: 'most_recent_activity',
        header: "Attività più recente",
        size: 200
      },
    ],
    []
  )


  useEffect(() => {
    setInfoString(
      <div>
        <span style={{ color: "red", fontWeight:"bold" }}><h2>Candidati disponibili</h2></span>
        <p><h3>Benvenuto nella home page del GPT Talent Placer.
                In questa sezione puoi utilizzare l’algoritmo di matching per le migliori posizioni lavorative per un candidato.
                Nella tabella principale trovi tutti i candidati disponibili ed inseriti a sistema entro le due ore precedenti. Utilizzando i filtri presenti nel menù a scomparsa sulla sinistra puoi cercare il candidato di tuo interesse. Inoltre, nell’angolo in alto a sinistra della tabella puoi trovare alcune funzionalità che ti permetteranno di filtrare i dati per una specifica colonna, nascondere le colonne che non ti interessa visualizzare e modificare la visualizzazione della tabella stessa.
                Una volta individuato il candidato di interesse, clicca sul tasto “Matching” per visualizzare le posizioni lavorative più affini. I risultati mostreranno le posizioni lavorative in un intorno (in linea d’aria) di 25km dal domicilio del candidato.
                Se, invece, il candidato non è presente a sistema clicca sul bottone “Candidati disponibili” per passare alla pagina “Definisci le caratteristiche del candidato”
                </h3></p>
      </div>
    )
    toggleView(true);
    fetch('/api/databricks/candidateread', {
      method: 'GET',
      headers: { 'Accept': 'application/json' } })
      .then(response => response.json())
      .then(data => setCandidates(data))
      .catch(error => console.error('Error fetching data:', error));
  }, [])

  const data: Candidate[] = candidates

  const table = useMaterialReactTable({
    columns,
    data,
    enableRowActions: true,
    positionActionsColumn: 'first',
    initialState: { density: 'compact' },
    enableStickyHeader: true,
    localization: {'actions':'Suggerimento'},
    muiTableContainerProps: {sx: { maxHeight: '500px' } },  
    renderRowActions: ({ row }) => (
      <div>
      <button type="submit" className="button-action-dir" onClick={() => setResult(row.original.Codice_Fiscale,row.original)}>
        <h4>MATCHING</h4>
      </button>
      </div>

  ),
  });

  return (
    <div>
      {isInfoPage ? 
      <div>
        <InfoPage infoString={infoString}></InfoPage>
      </div>
      :
    <div>
      {isReverseResult ?
      <div style={{textAlign:"center"}}>
        <div>
            <div id="menu-toggle-mobile">
              <div
                className={`container-toggle-dropdown mobile ${
                  isDropdownOpen ? "active" : ""
                }`}
                onClick={toggleDropdown}
              >
                <div>
                  {activeContent === "realtime" ? (
                    <>
                      <h4 className="m0">Candidati disponibili</h4>
                      <p className="m0">Cerca tra i candidati disponibili</p>
                    </>
                  ) : (
                    <>
                      <h4 className="m0">Definisci le caratteristiche del candidato</h4>
                      <p className="m0">Seleziona le caratteristiche richieste</p>
                    </>
                  )}
                </div>
                <img
                  width={12}
                  src={isDropdownOpen ? chevronUp : chevronDown}
                  alt={isDropdownOpen ? "Chevron up" : "Chevron down"}
                  className="chevron-icon"
                />
              </div>
              {isDropdownOpen && (
                <div className="dropdown-menu-mobile">
                  {activeContent === "normal" ? (
                    <div onClick={switchContent}>
                      <h4 className="m0">Candidati disponibili</h4>
                      <p className="m0">Cerca tra i candidati disponibili</p>
                    </div>
                  ) : (
                    <div onClick={switchContent}>
                      <h4 className="m0">Definisci le caratteristiche del candidato</h4>
                      <p className="m0">Seleziona le caratteristiche richieste</p>
                    </div>
                  )}
                </div>
              )}
            </div>
        </div>
        <div>
          {(candidates.length > 0 || timeElapsed) ? 
            <div>
              <SidebarRev isOpen={sidebarOpen} toggleSidebar={handleViewSidebar} setJ={setCandidates} timeE={setTimeElapsed} />
              <div className="back">
                <MaterialReactTable table={table} />
              </div>
              <div className="spacing-div">
                <h6>
                <strong>Nota bene: Analizza in modo critico i risultati!</strong><br />
                Utilizziamo una soluzione di intelligenza artificiale generativa (Azure OpenAI) per fornirvi i suggerimenti, preparare le email (candidato e cliente) e generare le domande da sottoporre al candidato in fase di colloquio. Vi invitiamo a usare uno spirito critico e a modificare o completare qualsiasi risposta che riteniate errata o inappropriata.
                </h6>
              </div>
            </div> : <div className="div-center">
            <div>
              <h3> Caricamento Candidati</h3>
            </div>
            <div style={{width:"100px", margin:"auto"}}>
              <LoaderComp></LoaderComp>
            </div >
        </div>}
        </div>
      </div> 
      : <TableMatches associate_id={associateId} row={row} headers={headers} 
          checkList={checkList} setCheckList={setCheckList}
          matches={matches} setMatches={setMatches} explain={explain} 
          setExplain={setExplain} isDetails={isDetails} iqg={iqg} email={email} emailC={emailC}
          setDetails={setDetails} setIqg={setIqg} setEmail={setEmail} setEmailC={setEmailC}
          emails={emails} setEmails={setEmails} emailsC={emailsC} setEmailsC={setEmailsC}
          questions={questions} setQuestions={setQuestions}
          headersNew={headersNew} setHeadersNew={setHeadersNew}
          cvs={cvs}
          setCvs={setCvs}
          urlPDF={urlPDF}
          setUrlPDF={setUrlPDF}
          rowValues={rowValues}
          setRowValues={setRowValues}
          jobId={jobId}
          setJobId={setJobId}
          codFisc={codFisc}
          setCodFisc={setCodFisc}
          jobInfo={jobInfo}
          setJobInfo={setJobInfo}
          jobInfos={jobInfos}
          setJobInfos={setJobInfos}
          timeJobInfo={timeJobInfo}
          setTimeJobInfo={setTimeJobInfo}
          interviste={interviste}
          setInterviste={setInterviste}
          ordini={ordini}
          setOrdini={setOrdini}
          ordine={ordine}
          setOrdine={setOrdine}
          intervista={intervista}
          setIntervista={setIntervista}
          timeOrdine={timeOrdine}
          setTimeOrdine={setTimeOrdine}
          timeIntervista={timeIntervista}
          setTimeIntervista={setTimeIntervista}
          cv={cv}
          setCv={setCv}
          timeCvsJob={timeCvsJob}
          setTimeCvsJob={setTimeCvsJob}
          isAI={isAI}
          setIsAI={setIsAI}
          initialOrder={initialOrderOffers}
          setInitialOrder={setInitialOrderOffers}
          defaultMatches={defaultMatches}
          setDefaultMatches={setDefaultMatches}
          isSeen={isSeen}
          setIsSeen={setIsSeen}
      ></TableMatches>}
    </div>
      }
    </div>
  )

}

export default TableCandidate;